import styled from "vue-styled-components";

export default styled.div`
  .header-modal {
    background-color: #2962ff;
  }
  .modal-button-custom {
    padding: 5px;
    width: 35px;
    height: 35px;
    border-radius: 20px;
    margin-top: 25px;
  }
  .button-group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 1.5em;
  }
`;
